import { Injectable } from '@angular/core';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts';

// Define the patterns used in PortfolioPerfChart
Highcharts.setOptions({
  defs: {
    hatchLeft: {
      tagName: 'pattern',
      id: 'hatch-left',
      patternUnits: 'userSpaceOnUse',
      width: 4,
      height: 4,
      children: [{
        tagName: 'path',
        d: 'M-1,1 l2,-2 M0,4 l4,-4 M3,5 l2,-2'
      }]
    }
  }
});
@Injectable({
  providedIn: 'root'
})
export class GenerateLineChartService {

  public getChart(): Chart {

    return new Chart({
      chart: {
        styledMode: true,
        zoomType: 'x',
        type: 'area',
        width: null,
        animation: false,
        // chart.reflow important to prevent charts from overlapping with container!
        events: {
          load() {
            // Identifiers are never reassigned better to use const in this case
            const chart = this;
            chart.reflow();
          }
        }
      },
      tooltip: {
        shared: true,
        valueDecimals: 2,
        // Wondering if HTML ability is an attack vector, script injects
        useHTML: true,
        xDateFormat: '<em>%d/%m/%Y</em>'
      },
      title: {
        text: ''
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      xAxis: {
        title: {
          text: ''
        }
      },
      credits: {
        enabled: false
      },
      // Prevent Animation of chart when rendering
      plotOptions: {
        area: {
          marker: {
            enabled: false
          }
        },
        series: {
          threshold: null,
          animation: false
        }

      },
      series: [
      ],
      responsive: {
        rules: [{
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'horizontal',
              align: 'center',
              verticalAlign: 'bottom'
            }
          }
        }]
      }
    });
  }
}


